export default __webpack_public_path__ + "static/media/logo.0d6c4cd7.svg";